import { render, staticRenderFns } from "./SharesCard.vue?vue&type=template&id=3323bb47&scoped=true"
import script from "./SharesCard.vue?vue&type=script&lang=js"
export * from "./SharesCard.vue?vue&type=script&lang=js"
import style0 from "./SharesCard.vue?vue&type=style&index=0&id=3323bb47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323bb47",
  null
  
)

export default component.exports